const path = process.env.VUE_APP_GEC_ML_API

const jwtPythonApi = {
  getTextFromImage(...args) {
    return this.axiosIns.post(`${path}/gec-ocr/get-text`, ...args)
  },
}

export default jwtPythonApi
